import { makeStyle } from "../../../../utils";
import { bold, h6, rowCenter, subTitle1, subTitle2 } from "../../../../resources/styles";
import view from "../../../../Enums";


const styles = {};


styles['container'] = makeStyle({ overflowY: 'auto', scrollBehavior: 'smooth' }, { flex: 1 });


styles['section'] = makeStyle({}, { maxWidth: 850, boxSizing: 'border-box', margin: '40px auto' });


styles['section_heading'] = makeStyle({ ...h6 }, { padding: '40px 60px' }, { padding: '32px 30px' }, { padding: '24px 24px' });


styles['underline'] = makeStyle({ width: '100%', height: 2, borderRadius: 1, backgroundColor: '#ddd', marginTop: 2 });


styles['content'] = makeStyle({}, { marginBottom: 40 }, { marginBottom: 32 }, { marginBottom: 24 });


styles['content_heading'] = makeStyle({ ...subTitle1, ...bold }, { padding: '26px 60px' }, { padding: '18px 30px' }, { padding: '8px 24px' });


styles['content_content'] = makeStyle({ ...subTitle2, fontFamily: 'Inter', textAlign: 'justify' }, { padding: '0px 60px' }, { padding: '0px 30px' }, { padding: '0px 24px' });


styles['go_to_top'] = makeStyle({
    ...rowCenter, ...subTitle2,
    backgroundColor: 'black',
    color: 'white',
    zIndex: 6,
    cursor: 'pointer',
}, {
    position: 'sticky', bottom: '12px', borderRadius: '24px', margin: '16px auto', width: 'max-content', padding: '8px 16px',
}, view.DESKTOP, {
    position: 'absolute', bottom: 96, borderRadius: '0 24px 24px 0', width: 48, height: 48, justifyContent: 'center',
});

styles['go_to_top_text'] = makeStyle({ marginLeft: 8 }, {}, {}, { display: 'none' });


export default styles;